<template>
  <div id="wrapper-total" v-on:keyup.enter="purchase">
    <span>{{$t("PURCHASE.TOTAL")}}: {{quantity}} {{$tc('SHOP.PRODUCT', quantity)}}</span>
    <span>
      <span style="font-weight: bold; margin-right: 2rem;">{{total | currency}}</span>
      <a v-on:click="purchase" class="waves-effect waves-light btn-large focusable" tabindex="-1">{{ $t("SHOP.BUY") }}</a>
    </span>

  </div>
</template>

<script>
import SpatialNavigation from 'js-spatial-navigation'

export default {
  name: 'CartTotal',
  props: ['quantity', 'total'],
  mounted: function () {
    this.SN = SpatialNavigation.add({selector: '#wrapper-total', restrict: 'self-first'})
    SpatialNavigation.makeFocusable(this.SN)
    SpatialNavigation.resume()
    SpatialNavigation.focus(this.SN)
  },
  methods: {
    purchase: function () {
      this.$store.commit('setPurchase', {
        type: 'cart',
        'total': this.total
      })
      this.$router.push({name: 'purchase-summary-cart'})
    }
  },
  beforeDestroy: function () { if (this.SN) SpatialNavigation.remove(this.SN) }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
#wrapper-total
  // position: absolute;
  // bottom: 0;
  // left: 0;
  // right: 0;
  position: relative
  width: 94vw
  margin: auto
  margin-bottom: 45px
  outline: none
  flex-wrap: wrap;

  display: flex
  display: -webkit-flex
  flex-direction: row
  justify-content: space-between
  align-items: center

  font-size: 1.7rem
  background-color: white
  padding: 1rem 3rem 1rem 3rem

</style>



// WEBPACK FOOTER //
// src/components/CartTotal.vue